import { apiHost } from '@/server/urls';
import { GET, POST } from '@/server/http';

export default async ({
    method = 'GET',
    action = '',
    params = {},
}, options = { showError: true }) => {
    const doAction = {
        GET: GET,
        POST: POST,
    }[method] || GET;
    const [ content, error, status ] = await doAction(`${apiHost}${action}`, params, options);
    if (error) return { error, status };
    return content || { value: '', status: '', info: '' };
};
